import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext(undefined);

export const UIProvider = ({ children }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <UIContext.Provider value={{ menuOpen, setMenuOpen }}>
            {children}
        </UIContext.Provider>
    );
};

export const useUI = () => {
    const ctx = useContext(UIContext);
    if (!ctx) throw new Error('useUI must be used within UIProvider');
    return ctx;
};
